import { useMutation, useQueryClient } from 'react-query'
import { fetchWrapper } from 'src/utils/fetchWrapper'
import { toast } from 'react-toastify'
import { useTranslation } from 'react-i18next'

export function useStageUpdate(workOrderID: number) {
  const API_ENDPOINT = `/workorders/${workOrderID}/pipeline/update`
  const queryClient = useQueryClient()
  const { t } = useTranslation()

  const updateStage = async (data: any) => {
    try {
      const updatedData = await fetchWrapper({
        method: 'PUT',
        url: API_ENDPOINT,
        body: data,
      })
      toast.success(t('Stage updated successfully'))
      return updatedData
    } catch (error) {
      console.error('API request failed:', error)
      toast.error(t('Failed to update stage'))
      throw error
    }
  }

  return useMutation('workOrderDetails', updateStage, {
    onSuccess: () => {
      queryClient.invalidateQueries('workOrderDetails')
    },
  })
}
